import { useEffect } from "react";
import { connect } from "react-redux";

import { autologin } from "modules/auth/actions";
import { push } from "connected-react-router";

const Autologin = (props) => {
  useEffect(() => {
    if (props.auth.user._id) {
      props.push('/home')
    } else {
      props.autologin({ autologintoken: props.match.params.autologintoken })
    }
  }, []) // eslint-disable-line
  return null;
}

const stateToProps = state => ({
  auth: state.auth,
  ui: state.ui
})

const dispatchToProps = {
  autologin,
  push
}

export default connect(stateToProps, dispatchToProps)(Autologin);